<template>
  <div>
    <el-dialog
      title="回收礼品卡"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="formInfo"
        :rules="formRules"
        ref="form"
        label-width="100px"
        size="small"
        v-loading="loading"
      >
        <el-form-item label="卡号" prop="cardNo">
          <el-input v-model="formInfo.cardNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡片面值" prop="amount">
          <el-input v-model="formInfo.amount" disabled></el-input>
        </el-form-item>
        <el-form-item label="会员信息">
          <el-input v-model="subscriberInfo" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡片类型" prop="cardType">
          <el-input v-model="formInfo.cardTypeName" disabled></el-input>
        </el-form-item>
        <el-form-item label="购买时间" prop="buyTime">
          <el-input v-model="formInfo.buyTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="激活时间" prop="activeTime">
          <el-input v-model="formInfo.activeTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="过期时间" prop="expiredTime">
          <el-input v-model="formInfo.expiredTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="回收原因" prop="recycleReason">
          <el-input
            type="textarea"
            v-model="formInfo.recycleReason"
            :rows="3"
            placeholder="请输入回收原因"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-popconfirm
          title="确认回收礼品卡吗？"
          confirmButtonText="确定"
          cancelButtonText="取消"
          icon="el-icon-question"
          @onConfirm="dataFormSubmit()"
        >
          <el-button slot="reference" type="primary">确认</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { giftCardRecycle } from "@/api/giftCard";
export default {
  name: "GiftCardRecycling",
  components: {},
  props: {},
  computed: {
    subscriberInfo() {
      return `${this.formInfo.subscriberName || ""}/(${this.formInfo
        .subscriberPhone || ""})`;
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      formInfo: {},
      formRules: {
        recycleReason: [
          { required: true, message: "请输入回收原因", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
      this.formInfo = {};
    },
    open(info) {
      this.formInfo = info;
      this.dialogVisible = true;
      this.loading = false;
    },
    dataFormSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    saveData() {
      this.loading = true;
      const data = {
        id: this.formInfo.id,
        recycleReason: this.formInfo.recycleReason
      };
      giftCardRecycle(data)
        .then(res => {
          if (res.data.status == 100) {
            this.$message.success("回收成功");
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// recyclingGiftCard.vue?ef130b08